import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';

const Terms: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>Terms & Conditions | Born in YU</title>
        <meta name="description" content="Read Born in YU's terms and conditions. Learn about our policies, user agreements, and legal information for shopping Yugoslav nostalgia apparel." />
        <link rel="canonical" href="https://borninyu.com/terms" />
      </Helmet>
      <main className="min-h-screen bg-white">
      <section className="p-6 md:p-24">
        <div className="max-w-4xl mx-auto">
          <div className="border-[3px] border-black p-8 md:p-16 relative">
            <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-white px-4 border-[3px] border-black font-black uppercase tracking-widest text-sm">
              {t('terms.classification')}
            </div>

            <h1 className="text-4xl md:text-6xl font-black uppercase tracking-tighter mb-8">
              {t('footer.links.terms')}
            </h1>

            <div className="font-typewriter text-sm leading-relaxed uppercase text-gray-800 space-y-6">
              <p className="text-xs text-gray-500">{t('terms.lastUpdated')}</p>

              <div className="border-l-4 border-black pl-6 py-4">
                <h3 className="font-black text-lg mb-2">{t('terms.acceptance')}</h3>
                <p>{t('terms.acceptanceText')}</p>
              </div>

              <div className="border-l-4 border-black pl-6 py-4">
                <h3 className="font-black text-lg mb-2">{t('terms.useLicense')}</h3>
                <p>{t('terms.useLicenseText')}</p>
              </div>

              <div className="border-l-4 border-black pl-6 py-4">
                <h3 className="font-black text-lg mb-2">{t('terms.prohibited')}</h3>
                <ul className="list-disc list-inside space-y-2">
                  <li>{t('terms.prohibitedItem1')}</li>
                  <li>{t('terms.prohibitedItem2')}</li>
                  <li>{t('terms.prohibitedItem3')}</li>
                  <li>{t('terms.prohibitedItem4')}</li>
                </ul>
              </div>

              <div className="border-l-4 border-black pl-6 py-4">
                <h3 className="font-black text-lg mb-2">{t('terms.productInfo')}</h3>
                <p>{t('terms.productInfoText')}</p>
              </div>

              <div className="border-l-4 border-black pl-6 py-4">
                <h3 className="font-black text-lg mb-2">{t('terms.pricing')}</h3>
                <p>{t('terms.pricingText')}</p>
              </div>

              <div className="border-l-4 border-black pl-6 py-4">
                <h3 className="font-black text-lg mb-2">{t('terms.limitation')}</h3>
                <p>{t('terms.limitationText')}</p>
              </div>

              <div className="border-2 border-black p-6 bg-gray-50 mt-8">
                <h3 className="font-black text-lg mb-4">{t('terms.governingLaw')}</h3>
                <p className="text-xs">{t('terms.governingLawText')}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
    </>
  );
};

export default Terms;
